export default __webpack_public_path__ + "static/media/KO_Banner_Flower_Right2.76de9589.png";